import { Grid } from "@mui/material";
import DepartmentList from "src/components/shared-components/department-list";

interface Props {
  onChange: (val: any) => void;
}

export default function DepartmentFilter({ onChange }: Props) {
  return (
    <Grid item xs={12} sm={6} md={2}>
      <DepartmentList handleChange={onChange} multiple={false} sx={{ width: "100%" }} />
    </Grid>
  );
}
